//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ISTHSSCDIC",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: ">100×10⁹/L" },
        { value: "1", name: "（50~100）×10⁹/L" },
        { value: "2", name: "<50×10⁹/L" },
      ],
      dataList1: [
        { value: "0", name: "不升高" },
        { value: "1", name: "轻度升高" },
        { value: "2", name: "显著升高" },
      ],
      dataList2: [
        { value: "0", name: "<3秒" },
        { value: "1", name: "3~6秒" },
        { value: "2", name: ">6秒" },
      ],
      dataList3: [
        { value: "0", name: "≥1g/L" },
        { value: "1", name: "<1g/L" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ISTHSSCDIC.vue